import { useApplyTheme } from '@/hooks/useTheme';
import { useKeyboardShortcuts } from '@/hooks/useKeyboardShortcuts';
import { useSyncRocketWithMission } from '@/hooks/useSyncRocketWithMission';
import { EducationCenter } from '@/components/EducationCenter';
import { AutosaveController } from './AutosaveController';
import { CommandBar } from './CommandBar';
import { DockLayout } from './DockLayout';
import { NotificationCenter } from './NotificationCenter';
import { Palette } from './Palette';
import { StatusBar } from './StatusBar';
import { TitleBar } from './TitleBar';

export function AppShell() {
  useApplyTheme();
  useKeyboardShortcuts();
  useSyncRocketWithMission();

  return (
    <div className="flex h-full flex-col bg-canvas text-text">
      <TitleBar />
      <CommandBar />
      <DockLayout />
      <StatusBar />
      <Palette />
      <EducationCenter />
      <NotificationCenter />
      <AutosaveController />
    </div>
  );
}
